// import { useContext } from "react";
// import { apiValue } from "./Data/AllData";

import BestDeal from "./Home/BestDeal";
import AllComponents from "./components/AllComponents";
import Footer from "./components/Footer";
import ContactHomeContent from "./Home/ContactHomeContent";
import Facts from "./Home/Facts";
import Banner from "./Home/Banner";
import ContactHome from "./Home/ContactHome";
import Featured from "./Home/Featured";
import Video from "./Home/Video";
import VideoContent from "./Home/VideoContent";
import PropertiesHome from "./Home/PropertiesHome";
import { CartProvider } from "react-use-cart";

function App() {
  // let test = useContext(apiValue)
  return (
    <CartProvider>
      <AllComponents />
      <Banner />
      <Featured />
      <Video />
      <VideoContent />
      <Facts />
      <BestDeal />
      <PropertiesHome />
      <ContactHome />
      <ContactHomeContent />
      <Footer />
    </CartProvider>
  );
}

export default App;
